import { IndustryCatalogType } from '@core/shared/domain';
import { FilterSelectionOption } from '@core/ui';

export const CATALOG_TYPE_FILTER_OPTIONS: FilterSelectionOption<IndustryCatalogType>[] = [
  { value: IndustryCatalogType.PurchasingGroup, label: 'Einkaufsgemeinschaftskatalog' },
  { value: IndustryCatalogType.Manufacturer, label: 'Herstellerkatalog' },
  { value: IndustryCatalogType.Dealer, label: 'Händlerkatalog' },
  { value: IndustryCatalogType.Hybrid, label: 'Hybridkatalog' },
];
